// Background Elements Imports
import Laddoo from '~images/onboarding/laddoo.svg';
import Kaju from '~images/onboarding/kaju.svg';
import Jalebi from '~images/onboarding/jalebi.svg';
import Sitara from '~images/onboarding/sitara.svg';
import Ladder from '~images/onboarding/ladder.svg';
import Fidget from '~images/onboarding/fidget.svg';
import Barfi from '~images/onboarding/mini-barfi.svg'

// Components Imports
import ChildName from '../components/new-onboarding/child-name/child-name';
import GradeSelection from '../components/new-onboarding/grade-selection/grade-selection';
import AgeSelection from '../components/new-onboarding/age-selection/age-selection';
import SubjectSelection from '../components/new-onboarding/subject-selection/subject-selection';
import OnboardingQuestions from '../components/new-onboarding/onboarding-questions/onboarding-question';
import BuildFocusArea from '../components/new-onboarding/build-focus-area/build-focus-area';
import PurchasePage from '../components/new-onboarding/purchase-page/purchase-page';
import SignupPage from '../components/new-onboarding/signup-page/signup-page';
import WeeklyGoalScreen from '../components/new-onboarding/weekly-goal/WeeklyGoalScreen';
import PersonalizeOptInScreen from '../components/new-onboarding/personalize-lp';

// Loadthrough Images Imports
import Multiply from '~images/onboarding/multiply.svg';
import Fractions from '~images/onboarding/fractions.svg';
import Shapes from '~images/onboarding/shapes.svg';
import Divide from '~images/onboarding/divide.svg';
import A from '~images/onboarding/A.svg';
import B from '~images/onboarding/B.svg';
import C from '~images/onboarding/C.svg';

// Grade Selection JSONs Imports
import GradePk from '../../json/splashverse-onboarding/grades/grade-pk.json';
import GradeK from '../../json/splashverse-onboarding/grades/grade-k.json';
import Grade1 from '../../json/splashverse-onboarding/grades/grade-1.json';
import Grade2 from '../../json/splashverse-onboarding/grades/grade-2.json';
import Grade3 from '../../json/splashverse-onboarding/grades/grade-3.json';
import Grade4 from '../../json/splashverse-onboarding/grades/grade-4.json';
import Grade5 from '../../json/splashverse-onboarding/grades/grade-5.json';

// Grade JSON for AU Users Imports
import GradePkAU from '../../json/splashverse-onboarding/grades-au/grade-pk.json';
import GradeKAU from '../../json/splashverse-onboarding/grades-au/grade-k.json';
import Grade1AU from '../../json/splashverse-onboarding/grades-au/grade-1.json';
import Grade2AU from '../../json/splashverse-onboarding/grades-au/grade-2.json';
import Grade3AU from '../../json/splashverse-onboarding/grades-au/grade-3.json';
import Grade4AU from '../../json/splashverse-onboarding/grades-au/grade-4.json';
import Grade5AU from '../../json/splashverse-onboarding/grades-au/grade-5.json';

// Personalize opt in screen JSONs
import NoSkip from '../../json/splashverse-onboarding/personalize-opt-in/no-skip.json';
import YesPersonalize from '../../json/splashverse-onboarding/personalize-opt-in/yes-personalize.json';

import LanguageKey from '../utils/locale-class';
import MentorMapping from '../components/new-onboarding/mentor-mapping/mentor-mapping';
import ProgramSelectionScreen from '../components/new-onboarding/program-selection-screen';
import AgeSelectionV2 from '../components/new-onboarding/age-selection-v2';
import ProgramDescriptionScreen from '../components/new-onboarding/program-description-screen';
import LoadThroughScreenOne from '../components/new-onboarding/load-through-screens/load-through-screen-1';
import LoadThroughScreenTwo from '../components/new-onboarding/load-through-screens/load-through-screen-2';
import LoadThroughScreenThree from '../components/new-onboarding/load-through-screens/load-through-screen-3';
import PersonaIdentification from '../components/new-onboarding/persona-identification';

export const VerticalMovementIndex = 50;
export const RotationalMovementIndex = 40;
export const BackgroundMovementDelay = 400;
export const MaxCharacterLimitInChildNameField = 12;
export const DefaultInputMaxLength = 524288;
export const OnboardingCarousalActiveDotMovementIndex = 26;
export const NumberOfQuestions = 5;

export const BackgroundElements = [
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 6,
      Y: 20,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 9,
      Y: 77,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'right',
      X: 4,
      Y: 36,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'right',
      X: 8,
      Y: 56,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'right',
      X: 5,
      Y: 98,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 12,
      Y: 170,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 4,
      Y: 200,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'right',
      X: 7,
      Y: 210,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 8,
      Y: 230,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 12,
      Y: 280,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 4,
      Y: 320,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'right',
      X: 7,
      Y: 340,
      deg: 0
    }
  },
  {
    img: Barfi,
    isSquareDots: true,
    initPos: {
      placement: 'left',
      X: 8,
      Y: 380,
      deg: 0
    }
  },
  {
    img: Laddoo,
    initPos: {
      placement: 'left',
      X: 0,
      Y: 50,
      deg: 0
    }
  },
  {
    img: Kaju,
    initPos: {
      placement: 'right',
      X: 5,
      Y: 90,
      deg: -40
    }
  },
  {
    img: Jalebi,
    initPos: {
      placement: 'left',
      X: -6,
      Y: 150,
      deg: 0
    }
  },
  {
    img: Sitara,
    initPos: {
      placement: 'right',
      X: 0,
      Y: 200,
      deg: 0
    }
  },
  {
    img: Ladder,
    initPos: {
      placement: 'left',
      X: 7,
      Y: 240,
      deg: -120
    }
  },
  {
    img: Fidget,
    initPos: {
      placement: 'right',
      X: 0,
      Y: 0,
      deg: 0
    }
  },
  {
    img: Laddoo,
    initPos: {
      placement: 'left',
      X: 0,
      Y: 340,
      deg: 0
    }
  },
  {
    img: Kaju,
    initPos: {
      placement: 'right',
      X: 5,
      Y: 390,
      deg: -40
    }
  },
  {
    img: Jalebi,
    initPos: {
      placement: 'left',
      X: -6,
      Y: 450,
      deg: 0
    }
  },
  {
    img: Sitara,
    initPos: {
      placement: 'right',
      X: 0,
      Y: 500,
      deg: 0
    }
  },
  {
    img: Ladder,
    initPos: {
      placement: 'left',
      X: 7,
      Y: 550,
      deg: -120
    }
  },
  {
    img: Fidget,
    initPos: {
      placement: 'right',
      X: 0,
      Y: 300,
      deg: 0
    }
  },
]

export const OnboardingStates = {
  'child_screen_name': {
    route: 'child-name',
    component: ChildName,
  },
  'grade_selection': {
    route: 'grade-select',
    component: GradeSelection,
  },
  'age_selection': {
    route: 'age-select',
    component: AgeSelection,
  },

  'subject_selection': {
    route: 'subject-select',
    component: SubjectSelection,
  },
  'onboarding_questions_math': {
    route: 'onboarding-questions',
    component: OnboardingQuestions,
  },
  'onboarding_questions_ela': {
    route: 'onboarding-questions',
    component: OnboardingQuestions,
  },
  'building_focus_area_math': {
    route: 'focus-area',
    component: BuildFocusArea,
  },
  'building_focus_area_ela': {
    route: 'focus-area',
    component: BuildFocusArea,
  },
  'purchase_page': {
    route: 'purchase-page',
    component: PurchasePage
  },
  'signup_page': {
    route: 'signup-page',
    component: SignupPage
  },
  'learning_partner_mapping_screen': {
    route: "lp-mapping",
    component: MentorMapping
  },
  'weekly_goal_screen':{
    route: "set-weekly-goal",
    component: WeeklyGoalScreen
  },
  'personalize_opt_in_screen': {
    route: "personalize-opt-in",
    component: PersonalizeOptInScreen
  },
  'program_selection_screen': {
    route: "program-selection-screen",
    component: ProgramSelectionScreen
  },
  'age_selection_v2': {
    route: "age-selection-screen-v2",
    component: AgeSelectionV2
  },
  'program_description_screen': {
    route: "program-description-screen",
    component: ProgramDescriptionScreen
  },
  'load_through_screen_1': {
    route: "load-through-screen-1",
    component: LoadThroughScreenOne
  },
  'load_through_screen_2': {
    route: "load-through-screen-2",
    component: LoadThroughScreenTwo
  },
  'load_through_screen_3': {
    route: "load-through-screen-3",
    component: LoadThroughScreenThree
  },
  'persona_identification': {
    route: "persona-identification",
    component: PersonaIdentification
  }
}

export const SubjectLoadthroughImages = {
  math: [Multiply, Divide, Fractions, Shapes],
  ela: [A, B, C]
}

export const GradeOverlappingPositions = [
  {
    left: 17,
    top: 33,
    code: 'pk',
    selectAnimation: LanguageKey() === 'au' ? GradePkAU : GradePk,
  },
  {
    left: 33,
    top: 29,
    code: 'k',
    selectAnimation: LanguageKey() === 'au' ? GradeKAU : GradeK,
  },
  {
    left: 50,
    top: 29,
    code: '1',
    selectAnimation: LanguageKey() === 'au' ? Grade1AU : Grade1,
  },
  {
    left: 66,
    top: 33,
    code: '2',
    selectAnimation: LanguageKey() === 'au' ? Grade2AU : Grade2,
  },
  {
    left: 25,
    top: 54,
    code: '3',
    selectAnimation: LanguageKey() === 'au' ? Grade3AU : Grade3,
  },
  {
    left: 42,
    top: 51,
    code: '4',
    selectAnimation: LanguageKey() === 'au' ? Grade4AU : Grade4,
  },
  {
    left: 58,
    top: 55,
    code: '5',
    selectAnimation: LanguageKey() === 'au' ? Grade5AU : Grade5,
  },
];

export const PersonalizeOptIn = [
  {
    left: 22.6,
    top: 30,
    code: 'no_skip',
    selectAnimation: NoSkip
  },
  {
    left: 52,
    top: 30,
    code: 'yes_personalize',
    selectAnimation: YesPersonalize
  }
];

export const nextGradeMap = {
    'pk': "Kindergarten",
    'k': 'Grade 1',
    '1': 'Grade 2',
    '2': 'Grade 3',
    '3': 'Grade 4',
    '4': 'Grade 5',
    '5': 'Champion'
};

export const gradesToSkipSubjectFor = ['pk', 'k'];

export const mentorAvailableGrades = ['3','4','5']